"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var LocationBold = function LocationBold(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: 'new 0 0 140 140'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M70,140c2.2,0,4.3-1.1,5.5-3c12.7-19.9,42.2-68.3,42.2-89.4C117.7,21.3,96.3,0,70,0S22.3,21.3,22.3,47.7 c0,21.1,29.5,69.5,42.2,89.4C65.7,138.9,67.8,140,70,140z M47.3,45.4c0-12.5,10.2-22.7,22.7-22.7s22.7,10.2,22.7,22.7 S82.5,68.1,70,68.1S47.3,57.9,47.3,45.4z"
  }));
};
LocationBold.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
LocationBold.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = LocationBold;